import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import SentryService from './utils/SentryService';
import AxiosInterceptor from './utils/axios';
import ReactGA from 'react-ga';
import config from './config/config';

AxiosInterceptor.initialize();

if (config.googleAnalyticsKey) {
  ReactGA.initialize(config.googleAnalyticsKey);
}

if (config.sentryDSN && config.frontendUrl) {
  SentryService.initialize(config.sentryDSN, config.frontendUrl);
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);
